import axios from "axios";

const axiosInstance = axios.create({
  baseURL: "https://saidul-expense-tracker.herokuapp.com/",
});

export default axiosInstance;
